import * as types from "./ActionTypes";
import * as profileApis from "../../apis/revshare/ProfileApis";
import { addActiveApiCall } from "./ActiveApiActions";

export function loadUserProfileSuccess(profile) {
  return { type: types.LOAD_USER_PROFILE_SUCCESS, profile };
}

export function setGhostUser(userToGhost) {
  return { type: types.SET_GHOST_USER,
      userToGhost: userToGhost ? userToGhost.employeeId : null,
      ghostEmployeeType: userToGhost ? userToGhost.employeeType : null,
      ghostShowOptions: userToGhost ? userToGhost.showOptions : null,
      ghostShowVouchers: userToGhost ? userToGhost.showVouchers : null,
      ghostIsManager: userToGhost ? userToGhost.isManager : null,
      ghostPtoEmployeeId: userToGhost ? userToGhost.ptoEmployeeId : null ,
      ghostDataEmployeeId: userToGhost ? userToGhost.dataEmployeeId : null,
      ghostIsAdmin: userToGhost ? userToGhost.isAdmin : null };
}

export function setThemeSetting(settings) {
  profileApis.setThemeSetting(settings);
  return { type: types.TOGGLE_DARK_THEME, useDarkTheme: settings.useDarkTheme };
}

export function loadUserProfile() {
  return function(dispatch) {
    dispatch(addActiveApiCall(types.LOAD_USER_PROFILE_SUCCESS));
    return profileApis
      .getUserProfile()
      .then(profile => {
        dispatch(loadUserProfileSuccess(profile));
      })
      .catch(error => {
        throw error;
      });
  };
}
